import styled from 'styled-components';

export const ViewInfoDBContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export default ViewInfoDBContainer;
